<template>
  <v-btn
    :block="block"
    :disabled="disabled"
    :loading="loading"
    :small="small"
    :href="href"
    :target="href ? target : undefined"
    color="primary"
    outlined
    class="saci-secondary-button"
    @click="handleClick"
  >
    <v-icon v-if="icon" :left="$slots.default" :small="small">
      {{ icon }}
    </v-icon>
    <slot />
  </v-btn>
</template>

<script>
export default {
  name: "SecondaryButton",
  props: {
    onClick: Function,
    icon: String,
    href: String,
    target: {
      type: String,
      default: "_blank"
    },
    small: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick(event) {
      if (this.onClick) this.onClick(event);
      this.$emit("click", event);
    }
  }
};
</script>

<style scoped>
.saci-secondary-button {
  border-radius: 8px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
}
</style>
